export default "__VITE_ASSET__DkIYfi2C__"